import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular/main';
import { ICellRendererParams } from 'ag-grid-community/main';

@Component({
    selector: 'test-subject-cell',
    template: require('./test-subject-ag-renderer.component.html'),
    styles: [require('./test-subject-ag-renderer.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class TestSubjectAgRendererComponent implements AgRendererComponent {

    public title: string;
    public hasDataRevision: boolean;

    public agInit(row: ICellRendererParams): void {

        if (!row.data || !row.value) {
            return;
        }

        this.title = row.value;
        this.hasDataRevision = row.data.hasSubjectDataRevision;
    }

    public refresh() {
        return false;
    }
}